import React from 'react';
import { ArrowRight, Lock, CreditCard, Check } from 'lucide-react';
export function PurchaseSection() {
  return <section id="purchase" className="py-24 px-4 bg-slate-950 relative overflow-hidden" data-id="element-110">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#FF6B35]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-111"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-112">
        <div className="bg-gradient-to-b from-slate-900 to-black border border-slate-800 rounded-2xl shadow-2xl overflow-hidden" data-id="element-113">
          <div className="bg-[#E63946] p-4 text-center" data-id="element-114">
            <p className="text-white font-bold text-lg animate-pulse" data-id="element-115">
              ⚠️ LA OFERTA TERMINA EN BREVE
            </p>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-116">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-117">
              Accede al Sistema Completo{' '}
              <span className="text-[#FF6B35]" data-id="element-118">ATRACCIÓN REAL™</span>
            </h2>
            <p className="text-slate-400 mb-8 max-w-2xl mx-auto" data-id="element-119">
              Descarga inmediata. Empieza a leer y aplicar en menos de 2
              minutos.
            </p>

            <div className="flex flex-col items-center justify-center mb-10" data-id="element-120">
              <div className="text-slate-500 text-xl line-through mb-2" data-id="element-121">
                $47.00 USD
              </div>
              <div className="text-6xl md:text-7xl font-black text-white tracking-tight flex items-start" data-id="element-122">
                <span className="text-3xl mt-2 mr-1" data-id="element-123">$</span>
                13.99
                <span className="text-xl mt-auto mb-2 ml-2 text-slate-400 font-medium" data-id="element-124">
                  USD
                </span>
              </div>
            </div>

            <a href="https://pay.hotmart.com/E104238125S?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xl mx-auto bg-[#2ecc71] hover:bg-[#27ae60] text-white text-xl md:text-2xl font-bold py-6 px-8 rounded-xl shadow-[0_0_30px_rgba(46,204,113,0.3)] hover:shadow-[0_0_40px_rgba(46,204,113,0.5)] transition-all duration-300 transform hover:-translate-y-1" data-id="element-125">
              <span className="flex items-center justify-center gap-3" data-id="element-126">
                QUIERO CAMBIAR MI VIDA AHORA
                <ArrowRight className="w-6 h-6" data-id="element-127" />
              </span>
            </a>

            <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm text-slate-500" data-id="element-128">
              <div className="flex items-center gap-2" data-id="element-129">
                <Lock className="w-4 h-4" data-id="element-130" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-131">
                <CreditCard className="w-4 h-4" data-id="element-132" />
                Acceso Inmediato
              </div>
              <div className="flex items-center gap-2" data-id="element-133">
                <Check className="w-4 h-4" data-id="element-134" />
                Garantía de Satisfacción
              </div>
            </div>

            <div className="mt-8 pt-8 border-t border-slate-800 grid grid-cols-2 md:grid-cols-4 gap-4 text-xs text-slate-500 uppercase tracking-wider" data-id="element-135">
              <div className="flex flex-col items-center gap-2" data-id="element-136">
                <span className="block w-8 h-8 bg-slate-800 rounded flex items-center justify-center" data-id="element-137">
                  📥
                </span>
                Descarga Digital
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-138">
                <span className="block w-8 h-8 bg-slate-800 rounded flex items-center justify-center" data-id="element-139">
                  📱
                </span>
                Multi-Dispositivo
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-140">
                <span className="block w-8 h-8 bg-slate-800 rounded flex items-center justify-center" data-id="element-141">
                  🔁
                </span>
                A tu ritmo
              </div>
              <div className="flex flex-col items-center gap-2" data-id="element-142">
                <span className="block w-8 h-8 bg-slate-800 rounded flex items-center justify-center" data-id="element-143">
                  ♾
                </span>
                Acceso Vitalicio
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}